
export const A11Y_ICON_LABEL_MAP = {
	'star-cube': 'Add favorite',
	'close-cube': 'Remove favorite',
	'current-location-wire-cube': 'Default location'
};
